/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
// OA A lot of ugly old stuff here. Too troublesome to fix all the linting so I suppressed some rules for now.
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */

import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { format as d3format } from 'd3-format';
import { timeFormat } from 'd3-time-format';
import { format, parseISO } from 'date-fns';
import { capitalize } from 'lodash';
import { AccessLevel, AccessSpace } from '../../../common/iam/access/types';
import { User, UserPlain } from '../../../common/iam/users/types';
import { CommentTargetType } from '../../../common/internal/comments/types';
import { EventTargetType } from '../../../common/internal/events/types';
import { JobStatus, JobType } from '../../../common/internal/jobs/types';
import { ResolverQualityLevel } from '../../../common/internal/product-resolver/types';
import { WithOptionalStartAndEndDate } from '../../../common/model/data-point-pickers/types';
import { stringToDateRange, toDateRangeAndYear } from '../../../common/model/date-ranges';
import { DateRange, DateRangeAndYear } from '../../../common/model/date-ranges/types';
import { MIN_EMPLOYEE_COUNT } from '../../../common/model/input/companies/data-points/employee-counts/consts';
import { MIN_REVENUE_IN_USD } from '../../../common/model/input/companies/data-points/revenues/consts';
import { RevenueShareClass } from '../../../common/model/input/companies/products/types';
import { CompanyRelationType } from '../../../common/model/input/companies/relations/types';
import {
  CompanyImpactDriverType,
  CompanyListingStatus,
  CompanyStatus,
  CompanyType,
} from '../../../common/model/input/companies/types';
import { DataSourcePublic } from '../../../common/model/input/data-sources/types';
import { MeasurableGroupType } from '../../../common/model/input/measurable-group/types';
import { TagType } from '../../../common/model/input/products/types';
import { ModelEntityType } from '../../../common/model/input/types';
import { FinalImpactScoreType, NetScoreFormat } from '../../../common/model/output/scores/types';
import { BibliometricSource, ExtendedValence, ValueChain } from '../../../common/model/types';
import { ProgressStatus, UpdateStatus } from '../../../common/model/update/progress/types';
import { SnapshotType } from '../../../common/model/versions/types';
import { friendlyShortImpactTitle } from '../../../common/utils';
import { convertToCurrency, convertToUsd } from '../../../common/utils/currency';

export const timestampFormatter = timeFormat('%d/%m/%Y %H:%M:%S');

export function friendlyProductDescription(description: string | undefined, title: string) {
  if (description === '-' || !description) {
    return lowercaseFirstLetter(title);
  }
  return description;
}

export function lowercaseFirstLetter(text: string) {
  return text.charAt(0).toLowerCase() + text.slice(1);
}

export function uppercaseFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function friendlyValueChainExternal(valueChain: ValueChain) {
  switch (valueChain) {
    case ValueChain.DOWNSTREAM:
      return 'Downstream';
    case ValueChain.INTERNAL:
      return 'Internal';
    case ValueChain.UPSTREAM:
      return 'Upstream';
    case ValueChain.ANY:
      return 'Any';
  }
}

export function friendlyValueChain(valueChain: ValueChain) {
  switch (valueChain) {
    case ValueChain.DOWNSTREAM:
      return 'Downstream';
    case ValueChain.INTERNAL:
      return 'Internal';
    case ValueChain.UPSTREAM:
      return 'Upstream';
    case ValueChain.ANY:
      return 'Any';
  }
}

export function friendlyTagType(tagType: TagType) {
  switch (tagType) {
    case TagType.DOWNSTREAM:
      return 'Downstream';
    case TagType.ENABLES:
      return 'Enables';
    case TagType.BLACKLIST:
      return 'Blacklist';
    case TagType.CRITICAL:
      return 'Critical';
    case TagType.UPSTREAM:
      return 'Upstream';
    case TagType.ENABLED_BY:
      return 'Enabled by';
  }
}

export function friendlyShortestImpactTitle(impactCode: string) {
  if (impactCode === ImpactCategoryId.KNOWLEDGE_INFRA) {
    return 'Knwl. infra';
  }
  if (impactCode === ImpactCategoryId.CREATES_KNOWLEDGE) {
    return 'Creating knwl.';
  }
  if (impactCode === ImpactCategoryId.DISTRIBUTING_KNOWLEDGE) {
    return 'Distributing knwl.';
  }
  if (impactCode === ImpactCategoryId.SOCIETAL_INFRA) {
    return 'Societal infra';
  }
  return friendlyShortImpactTitle(impactCode);
}

export function friendlyExtendedValence(valence: ExtendedValence) {
  switch (valence) {
    case ExtendedValence.POSITIVE:
      return 'Pos';
    case ExtendedValence.NEGATIVE:
      return 'Neg';
    case ExtendedValence.SMALL_NEGATIVE:
      return 'S-Neg';
    case ExtendedValence.OTHER:
      return 'Other';
  }
}

export function friendlyLongExtendedValence(valence: ExtendedValence) {
  switch (valence) {
    case ExtendedValence.POSITIVE:
      return 'Positive';
    case ExtendedValence.NEGATIVE:
      return 'Negative';
    case ExtendedValence.SMALL_NEGATIVE:
      return 'Negative but less than most common contrafactual';
    case ExtendedValence.OTHER:
      return 'Other';
  }
}

export function friendlyNetScoreFormat(netScoreFormat: NetScoreFormat) {
  switch (netScoreFormat) {
    case NetScoreFormat.NET_RATIO:
    case NetScoreFormat.NET_RATIO_DECIMAL:
      return 'Net impact ratio';
    case NetScoreFormat.NET_SUM:
      return 'Net score';
  }
}

export function friendlyShortScoreUnit(unit: FinalImpactScoreType) {
  switch (unit) {
    case FinalImpactScoreType.CENTS_PER_DOLLAR:
      return '¢/$';
    case FinalImpactScoreType.DOLLARS_PER_YEAR:
      return 'Impact dollars per year';
    case FinalImpactScoreType.RELATIVE:
      return 'Classic scores';
    case FinalImpactScoreType.ABSOLUTE:
    default:
      return unit;
  }
}

export const aiName = 'Leena-Leena';

export function friendlyRevenueShareClass(revenueShareClass: RevenueShareClass) {
  switch (revenueShareClass) {
    case RevenueShareClass.MINOR:
      return 'Minor';
    case RevenueShareClass.MEDIUM:
      return 'Medium';
    case RevenueShareClass.MAJOR:
      return 'Major';
    case RevenueShareClass.UNKNOWN:
    default:
      return 'Unknown';
  }
}

export function ratioToPercentage(ratio: number) {
  return `${(ratio * 100).toFixed(2)}%`;
}

export function ratioToPercentageNumber(ratio: number) {
  return Math.round(ratio * 100);
}

export function friendlyProgressStatus(status?: ProgressStatus) {
  if (!status) {
    return 'Unknown';
  }
  switch (status) {
    case ProgressStatus.SUCCESS:
      return 'Success';
    case ProgressStatus.RUNNING:
      return 'Running';
    case ProgressStatus.FAILED:
      return 'Failed';
    case ProgressStatus.QUEUED:
      return 'Queued';
    case ProgressStatus.SKIPPED:
      return 'Skipped';
  }
}

export function friendlySnapshotType(type?: SnapshotType) {
  if (!type) {
    return 'Unknown';
  }
  switch (type) {
    case SnapshotType.BASIC:
      return 'Basic';
    case SnapshotType.MASTER:
      return 'Master';
    case SnapshotType.FULL:
      return 'Full';
    case SnapshotType.LEGACY:
      return 'Legacy';
    case SnapshotType.PUBLISHABLE:
      return 'Publishable';
    case SnapshotType.DELETED:
      return 'Deleted';
    case SnapshotType.DOWNGRADED:
      return 'Downgraded';
  }
}

export function formatDate(date: Date | number) {
  return format(date, 'd.M.yyyy');
}

export function formatDateTime(date: Date | number | undefined) {
  if (!date) {
    return `N/A`;
  }
  return format(date, `dd.MM.yyyy HH:mm:ss`);
}

export function formatTimestamp(timestamp: string): string {
  const date = parseISO(timestamp);
  return formatDateTimeCompact(date);
}

export function formatDateTimeCompact(date: Date) {
  return format(date, `dd.MM.yyyy HH:mm`);
}

export function friendlyUpdateStatus(status: UpdateStatus) {
  switch (status) {
    case UpdateStatus.ERROR:
      return 'Error';
    case UpdateStatus.INITIAL:
      return 'Not yet run';
    case UpdateStatus.SUCCESS:
      return 'Success';
    case UpdateStatus.UPDATING:
      return 'Updating...';
  }
}

export function friendlyRevenueWithMinimum(
  revenue: number,
  currency: string,
  precision?: 'millions' | 'billions' | 'trillions',
  decimalsToShow?: number,
) {
  if (convertToUsd(revenue, currency) < MIN_REVENUE_IN_USD) {
    revenue = convertToCurrency(MIN_REVENUE_IN_USD, 'USD', currency);
  }
  return friendlyRevenue(revenue, currency, precision, decimalsToShow);
}

export function friendlyRevenue(
  revenue: number,
  currency: string,
  precision?: 'millions' | 'billions' | 'trillions',
  decimalsToShow?: number,
) {
  switch (currency) {
    case 'EUR':
      currency = '€';
      break;
    case 'USD':
      currency = '$';
      break;
  }

  const { divider, precisionSign } = (p => {
    switch (p) {
      case 'millions':
        return { divider: 1_000_000, precisionSign: 'M' };
      case 'billions':
        return { divider: 1_000_000_000, precisionSign: 'B' };
      case 'trillions':
        return { divider: 1_000_000_000_000, precisionSign: 'T' };
      case undefined:
      default:
        return { divider: 1_000_000, precisionSign: 'M' };
    }
  })(precision);

  const formatted = d3format(`,.${decimalsToShow !== undefined ? decimalsToShow : '2'}f`)(revenue / divider);
  return `${formatted} ${precisionSign}${currency}`;
}

export function friendlyCurrencyName(ticker: string) {
  const currencyFormatter = new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: ticker,
    currencyDisplay: 'name',
  });
  const zeroCoins = currencyFormatter.format(0);
  return zeroCoins.slice(zeroCoins.indexOf(' ')).trim();
}

export function friendlyMoney(amount?: number, showMillions?: boolean, currency?: string, divideByMillion?: boolean) {
  if (!amount) {
    return undefined;
  }
  const replacedCurrency = (() => {
    switch (currency) {
      case 'EUR':
        return '€';
      case 'USD':
        return '$';
      case undefined:
      default:
        return currency;
    }
  })();

  const formatted = divideByMillion ? d3format(',.2f')(amount / 1_000_000) : d3format(',.2f')(amount);

  if (showMillions) {
    return `${formatted} M${replacedCurrency || ''}`;
  } else {
    return `${formatted}${replacedCurrency || ''}`;
  }
}

export function friendlyEmployeeCount(employeeCount: number) {
  if (employeeCount < MIN_EMPLOYEE_COUNT) {
    employeeCount = MIN_EMPLOYEE_COUNT;
  }
  return friendlyBigNumber(employeeCount);
}

export function friendlyBigNumber(value: number, decimals?: number) {
  if (decimals === undefined) {
    return d3format(',')(value);
  } else {
    return d3format(`,.${decimals}f`)(value);
  }
}

export function shortenedBigNumber(value: number, decimals?: number, spaceBetween = false): string {
  const B = 1_000_000_000;
  const M = 1_000_000;
  const k = 1_000;
  const delim = spaceBetween ? ' ' : '';
  if (value >= B) {
    return `${friendlyBigNumber(value / B, decimals)}${delim}B`;
  } else if (value >= M) {
    return `${friendlyBigNumber(value / M, decimals)}${delim}M`;
  } else if (value >= k) {
    return `${friendlyBigNumber(value / k, decimals)}${delim}k`;
  } else {
    // Below 1k there is no suffix, so the value must be shown as-is — do NOT
    // divide by k here, or e.g. 40 renders as "0" at decimals=0.
    return `${friendlyBigNumber(value, decimals)}`;
  }
}
export function tablePlainSum(values: any[]) {
  const sum = values.reduce((total: number, value) => {
    if (value) {
      return total + parseFloat(value);
    } else {
      return total;
    }
  }, 0);

  return sum > 0 ? `${sum}` : '';
}

export function tableMoneySum(values: any[]) {
  const plainSum = tablePlainSum(values);
  if (plainSum === '') {
    return '';
  }
  return d3format(',.0f')(+plainSum);
}

export function getTableFooterText(text: string) {
  return (_values: any[]) => {
    return text;
  };
}

export function friendlyCommentTargetType(type: CommentTargetType) {
  switch (type) {
    case CommentTargetType.COMPANY_DESCRIPTION:
      return 'a description';
    case CommentTargetType.COMPANY_EMPLOYEE_COUNT:
      return 'an employee count data point';
    case CommentTargetType.COMPANY_INCOME:
      return 'an income data point';
    case CommentTargetType.COMPANY_PRODUCT_SET:
      return 'a product set';
    case CommentTargetType.COMPANY_REVENUE:
      return 'a revenue data point';
    case CommentTargetType.PRODUCT_MARKET_SIZE:
      return 'the market size';
    case CommentTargetType.ENTITY_QUALITY_CHECK:
      return 'a quality check';
    case CommentTargetType.COMPANY:
    case CommentTargetType.COMPANY_GROUP:
    case CommentTargetType.PORTFOLIO:
    case CommentTargetType.PRODUCT:
    case CommentTargetType.PRODUCT_PHRASE_TAG:
      return '';
    case CommentTargetType.BLANKET_PRODUCT_SET:
    case CommentTargetType.CONSTRAINT_SET:
    default:
      return type;
  }
}

export function friendlyEventTargetType(type: EventTargetType) {
  // switch (type) {
  //   case EventTargetType.ADMIN:
  //     return 'Admin';
  //   case EventTargetType.PRODUCT:
  //     return 'Product';
  //   case EventTargetType.COMPANY:
  //     return 'Company';
  //   case EventTargetType.COMPANY_GROUP:
  //     return 'Company group';
  //   case EventTargetType.PORTFOLIO:
  //     return 'Portfolio';
  //   case EventTargetType.IMPACT:
  //     return 'Impact';
  //   case EventTargetType.ARTICLE:
  //     return 'Article';
  //   case EventTargetType.CONTRIBUTION:
  //     return 'Contribution';
  //   case EventTargetType.USER:
  //     return 'User';
  //   case EventTargetType.USER_GROUP:
  //     return 'User group';
  //   case EventTargetType.DOWNLOAD:
  //     return 'Download';
  //   case EventTargetType.CONSTRAINT:
  //     return 'Constraint';
  //   case EventTargetType.CONSTRAINT_SET:
  //     return 'Constraint set';
  // }
  return uppercaseFirstLetter(type.toLocaleLowerCase().replace('_', ' '));
}

export function userNameText(user: User | UserPlain) {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  } else {
    return user.username;
  }
}

export function friendlyQualityLevel(level: ResolverQualityLevel) {
  switch (level) {
    case ResolverQualityLevel.HIGH:
      return 'High';
    case ResolverQualityLevel.MEDIUM_PLUS:
      return 'Medium+';
    case ResolverQualityLevel.MEDIUM:
      return 'Medium';
    case ResolverQualityLevel.LOW:
      return 'Low';
    case ResolverQualityLevel.VERY_LOW:
      return 'Very low';
    case ResolverQualityLevel.POOR:
      return 'Poor';
  }
}

export function friendlyCompanyStatus(status: CompanyStatus) {
  switch (status) {
    case CompanyStatus.ACTIVE:
      return 'Active';
    case CompanyStatus.INACTIVE_ACQUIRED:
      return 'Inactive: Acquired or merged into another company';
    case CompanyStatus.INACTIVE_BANKRUPTED:
      return 'Inactive: Bankrupted';
    case CompanyStatus.INACTIVE_OTHER:
      return 'Inactive: Other reason';
    case CompanyStatus.DRAFT:
    default:
      return undefined;
  }
}

export function friendlyCompanyType(type: CompanyType | undefined) {
  if (!type) {
    return 'company';
  }
  switch (type) {
    case CompanyType.COMPANY:
      return 'company';
    case CompanyType.CUSTOMER_SCENARIO:
      return 'customer scenario';
    case CompanyType.BUSINESS_UNIT:
      return 'business unit';
    case CompanyType.NOT_A_COMPANY:
      return 'non-company';
    case CompanyType.GREEN_BOND:
      return 'green bond';
    case CompanyType.SOCIAL_BOND:
      return 'social bond';
    case CompanyType.SUSTAINABLE_BOND:
      return 'sustainable bond';
    case CompanyType.SUSTAINABILITY_LINKED_BOND:
      return 'sustainability linked bond';
    case CompanyType.CASH:
      return 'cash';
    case CompanyType.PUBLIC_SECTOR:
      return 'public sector';
    case CompanyType.COMMODITY:
      return 'commodity';
  }
}

export function friendlyAccessSpace(accessSpace: AccessSpace) {
  switch (accessSpace) {
    case AccessSpace.SHARED:
      return 'Shared';
    case AccessSpace.PROMISED_PUBLIC:
      return 'Promised public';
    case AccessSpace.PRIVATE:
      return 'Private';
    case AccessSpace.SEMIPRIVATE:
      return 'Semi-private';
  }
}

export function friendlyGroupType(type?: MeasurableGroupType, fallback?: string): string {
  switch (type) {
    case MeasurableGroupType.FUND:
      return 'fund';
    case MeasurableGroupType.CLIENTS:
      return 'client portfolio';
    case MeasurableGroupType.INDEX:
      return 'index';
    case MeasurableGroupType.GENERIC:
      return 'company group';
    case MeasurableGroupType.WEIGHTED_PORTFOLIO:
      return 'portfolio';
    case MeasurableGroupType.UNWEIGHTED_PORTFOLIO:
      return 'unweighted portfolio';
    case MeasurableGroupType.LOANS:
      return 'loan portfolio';
    case MeasurableGroupType.GRANT_RECIPIENTS:
      return 'grant recipients';
    case MeasurableGroupType.WEIGHTED_PORTFOLIO_PRIVATE:
    case undefined:
    default:
      if (type !== undefined) {
        return type;
      }
      if (fallback !== undefined) {
        return fallback;
      }
      return 'group';
  }
}

export function friendlyEntityTitle(
  entityType: ModelEntityType | undefined,
  groupType?: MeasurableGroupType,
  companyType?: CompanyType,
  fallback: string = 'Loading...',
) {
  const text = (() => {
    if (entityType) {
      return friendlyEntityTypeWithSubType(entityType, groupType || companyType);
    }
    return fallback;
  })();
  return text.toUpperCase();
}

export function friendlyEntityTypeWithSubType(
  entityType: ModelEntityType,
  subType?: MeasurableGroupType | CompanyType,
) {
  const friendlyEntityType = friendlyModelEntityType(entityType);
  switch (entityType) {
    case ModelEntityType.COMPANY: {
      const companyType = subType as CompanyType | undefined;
      return companyType ? friendlyCompanyType(companyType) : friendlyEntityType;
    }
    case ModelEntityType.GROUP:
    case ModelEntityType.PORTFOLIO: {
      const groupType = subType as MeasurableGroupType | undefined;
      return groupType ? friendlyGroupType(groupType) : friendlyEntityType;
    }
    case ModelEntityType.MIXIN:
    case ModelEntityType.PHENOMENON:
    case ModelEntityType.PRODUCT:
    default:
      return friendlyEntityType;
  }
}

export function friendlyCompanyImpactDriverType(type: CompanyImpactDriverType | undefined) {
  switch (type) {
    case undefined:
    case CompanyImpactDriverType.BASIC:
      return 'Basic';
    case CompanyImpactDriverType.INVESTMENT:
      return 'Investment company';
    case CompanyImpactDriverType.PROFESSIONAL_SERVICES:
      return 'Professional services company';
    case CompanyImpactDriverType.RETAIL:
      return 'Retail company';
  }
}

export function friendlyCompanyListingStatus(type: CompanyListingStatus | undefined | null) {
  switch (type) {
    case undefined:
    case null:
      return 'Unknown (default)';
    case CompanyListingStatus.PUBLIC:
      return 'Public';
    case CompanyListingStatus.PRIVATE:
      return 'Private';
  }
}

export function friendlyCompanyRelationType(type: CompanyRelationType) {
  switch (type) {
    case CompanyRelationType.COUNTRY_ORGANIZATION:
      return 'Country organization';
    case CompanyRelationType.BOND:
      return 'Bond';
    case CompanyRelationType.SUBSIDIARY:
      return 'Subsidiary';
    case CompanyRelationType.PORTFOLIO_COMPANY:
      return 'Portfolio company';
    case CompanyRelationType.OTHER:
      return 'Other owned company';
  }
}

export function companyRelationDescription(type: CompanyRelationType) {
  switch (type) {
    case CompanyRelationType.COUNTRY_ORGANIZATION:
      return 'Completely owned by the parent company, inherits the full product set of the parent';
    case CompanyRelationType.SUBSIDIARY:
      return 'Majority owned by the parent company.';
    case CompanyRelationType.BOND:
      return 'A bond issued by the parent.';
    case CompanyRelationType.PORTFOLIO_COMPANY:
      return 'Partially or completely owned by the parent company. Does NOT inherit the product set of the parent. Parent IS a holding company, and has no own product set.';
    case CompanyRelationType.OTHER:
      return "Any case that doesn't fit the above options";
  }
}

interface WithSourceIdAndObject {
  source?: string;
  sourceObject?: DataSourcePublic;
}

export function friendlySource<T extends WithSourceIdAndObject>(withSourceIdAndObject?: T) {
  const unknown = forbidLineBreaks('Unknown source');
  if (!withSourceIdAndObject) {
    return unknown;
  }
  const { source, sourceObject } = withSourceIdAndObject;
  if (sourceObject) {
    return forbidLineBreaks(sourceObject.name);
  }
  if (!source) {
    return unknown;
  }
  return forbidLineBreaks(uppercaseFirstLetter(source));
}

export function forbidLineBreaks(text: string) {
  return text.split(' ').join('\xa0');
}

export function friendlyInSentenceModelEntityType(type: ModelEntityType) {
  switch (type) {
    case ModelEntityType.COMPANY:
      return 'company';
    case ModelEntityType.GROUP:
      return 'group of companies';
    case ModelEntityType.PORTFOLIO:
      return 'portfolio';
    case ModelEntityType.PRODUCT:
    case ModelEntityType.MIXIN:
      return 'product';
    case ModelEntityType.PHENOMENON:
      return 'phenomenon';
  }
}

/**
 *
 * @param accessLevel Access level to transform to text
 * @param isTeam Flag if all access levels should be revealed. Defaults to true
 * @returns Access level name in English
 */
export function friendlyAccessLevel(accessLevel: AccessLevel, isTeam: boolean = true) {
  if (isTeam) {
    switch (accessLevel) {
      case AccessLevel.OWNER:
        return 'Owner';
      case AccessLevel.EDIT:
        return 'Edit';
      case AccessLevel.READ_ONLY:
        return 'Read only';
      case AccessLevel.READ_OUTPUT:
        return 'Read (restricted)';
      case AccessLevel.READ_WITHOUT_WEIGHTS:
        return 'Read without weights';
      case AccessLevel.READ_TEASER:
        return 'Read summary data only';
      case AccessLevel.SEARCH_ONLY:
        return 'Search only';
    }
  } else {
    // For non-team users, do not display differences between different read accesses
    switch (accessLevel) {
      case AccessLevel.OWNER:
        return 'Owner';
      case AccessLevel.EDIT:
        return 'Edit';
      case AccessLevel.READ_OUTPUT:
        return 'Read (restricted)';
      case AccessLevel.READ_ONLY:
      case AccessLevel.READ_WITHOUT_WEIGHTS:
        return 'Read only';
      case AccessLevel.READ_TEASER:
        return 'Read summary data only';
      case AccessLevel.SEARCH_ONLY:
        return 'Search only';
    }
  }
}

export function friendlyModelEntityType(type: ModelEntityType) {
  switch (type) {
    case ModelEntityType.PORTFOLIO:
      return 'Portfolio';
    case ModelEntityType.GROUP:
      return 'Company group';
    case ModelEntityType.COMPANY:
      return 'Company';
    case ModelEntityType.PRODUCT:
    case ModelEntityType.MIXIN:
      return 'Product';
    case ModelEntityType.PHENOMENON:
      return 'Phenomenon';
  }
}

export function friendlyJobStatus(type: JobStatus) {
  switch (type) {
    case JobStatus.ERROR:
      return 'Error';
    case JobStatus.QUEUED:
      return 'Queued';
    case JobStatus.RUNNING:
      return 'Running';
    case JobStatus.IDLE:
      return 'Idle';
    case JobStatus.SUCCESS:
      return 'Success';
    case JobStatus.DELAYED:
      return 'Delayed';
  }
}

export function friendlyJobType(type: JobType) {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (type) {
    case JobType.COMPUTE_COMPANY:
      return 'Compute company';
    case JobType.COMPUTE_COMPANIES:
      return 'Compute companies';
    case JobType.COMPUTE_WEIGHT_SETS:
      return 'Compute groups or portfolios';
    case JobType.COMPUTE_WEIGHT_SET:
      return 'Compute group or portfolio';
    case JobType.MATCH_WEIGHT_SET_ITEMS:
      return 'Match weight set items';
    case JobType.QUANDL_EXPORT:
      return 'Generate Quandl release files';
    case JobType.ARTICLE_MATCH_PREDICTION:
      return 'Article match prediction (classification)';
    case JobType.MERGED_ARTICLE_MATCH_PREDICTION:
      return 'Merged article match prediction';
    case JobType.FULL_SCORES_LEAF:
      return 'Full scores (leaf, legacy)';
    case JobType.FULL_SCORES_LEAF_V2:
      return 'Full leaf scores';
    case JobType.FINAL_SCORES_NONLEAF:
      return 'Final scores (nonleaf, legacy)';
    case JobType.FINAL_SCORES_NONLEAF_V2:
      return 'Final non-leaf scores';
    case JobType.SEC_FUND_IMPORT:
      return 'External data import';
    case JobType.TERM_PAIR_MATCH_COUNT:
      return 'Term pair match count';
    case JobType.PRODUCT_TERM_MATCH_COUNT:
      return 'Product term match count';
    case JobType.MODEL_UPDATE:
      return 'Model update';
    case JobType.MODEL_UPDATE_STEP:
      return 'Model update step';
    case JobType.OPTIMIZED_FLOWS:
      return 'Product flow optimization';
    case JobType.TRIGGER_AUTO_MODEL_UPDATE:
      return 'Trigger auto model update';
    case JobType.CONSTRAINED_SCORES:
      return 'Constrained scores';
    case JobType.POPULATE_COMPANY_IDENTIFIERS:
      return 'Company identifiers population';
    case JobType.ALLOCATION_MATRIX:
      return 'Allocation (legacy)';
    case JobType.ALLOCATION_TABLE_UPDATE:
    case JobType.ALLOCATION_TABLE_UPDATE_V2:
      return 'Allocation (finalization)';
    case JobType.ALLOCATION_MATRIX_V2:
      return 'Allocation';
    case JobType.FULL_SCORE_CONTRIBUTION:
      return 'Full score contributions';
    case JobType.CONSTRAINT_PROBLEMS:
      return 'Constraint dry runs';
    case JobType.CONSTRAINT_PROBLEMS_CHILD_JOB:
      return 'Constraint dry run';
    case JobType.TRIGGER_AUTO_CONSTRAINT_PROBLEMS_JOB:
      return 'Automatic constraint dry run';
    case JobType.TRIGGER_AUTO_TAXONOMY_PROBLEMS_JOB:
      return 'Automatic taxonomy problems job';
    default:
      return capitalize(type).replaceAll('-', ' ');
  }
}

export function friendlyBibliometricSource(source: BibliometricSource) {
  switch (source) {
    case BibliometricSource.CORE:
      return 'CORE';
    case BibliometricSource.WIKI:
      return 'Wikipedia';
    case BibliometricSource.CORE2:
    default:
      return 'Unknown bibliometric source';
  }
}

export function productNoun(isPhenomenon: boolean) {
  return isPhenomenon ? 'phenomenon' : 'product';
}

export function productNounCapitalized(isPhenomenon: boolean) {
  return isPhenomenon ? 'Phenomenon' : 'Product';
}

export function friendlyDateRange(dateRange: DateRange) {
  switch (dateRange) {
    case DateRange.Q1:
      return 'Q1';
    case DateRange.Q2:
      return 'Q2';
    case DateRange.Q3:
      return 'Q3';
    case DateRange.Q4:
      return 'Q4';
    case DateRange.YEAR:
      return 'Whole year';
    case DateRange.M1:
      return 'Jan';
    case DateRange.M2:
      return 'Feb';
    case DateRange.M3:
      return 'Mar';
    case DateRange.M4:
      return 'Apr';
    case DateRange.M5:
      return 'May';
    case DateRange.M6:
      return 'Jun';
    case DateRange.M7:
      return 'Jul';
    case DateRange.M8:
      return 'Aug';
    case DateRange.M9:
      return 'Sep';
    case DateRange.M10:
      return 'Oct';
    case DateRange.M11:
      return 'Nov';
    case DateRange.M12:
      return 'Dec';
    default:
      throw Error('Unexpected date range!');
  }
}

export function toFriendlyDateString(input: string): string {
  const dateParts = input.split(' ');
  const year = dateParts[0];
  const yearOrMonthOrQuarter = dateParts.pop();
  const dateRange = stringToDateRange(yearOrMonthOrQuarter);
  return dateRange === DateRange.YEAR ? year : `${year} ${friendlyDateRange(dateRange)}`;
}

export function formatDateRange(input: DateRangeAndYear | undefined | WithOptionalStartAndEndDate) {
  if (!input) {
    return '';
  }
  const dateRangeAndYear =
    !!(input as WithOptionalStartAndEndDate).startDate && !!(input as WithOptionalStartAndEndDate).endDate
      ? toDateRangeAndYear(input as WithOptionalStartAndEndDate)
      : (input as DateRangeAndYear);
  if (!dateRangeAndYear) {
    return '';
  }
  const { dateRange, year } = dateRangeAndYear;
  if (dateRange === DateRange.YEAR) {
    return `${year}`;
  }
  return `${year} ${dateRange}`;
}

export function friendlyWeightSetDates(withDates: WithOptionalStartAndEndDate) {
  return formatDateRange(toDateRangeAndYear(withDates));
}

export function getPossessiveForm(name: string): string {
  if (!name) return '';

  const trimmedName = name.trim();
  const lastChar = trimmedName.charAt(trimmedName.length - 1).toLowerCase();

  const endsInS = lastChar === 's';

  return endsInS ? `${trimmedName}'` : `${trimmedName}'s`;
}
